import React from 'react';
import WorkDetail from './WorkDetail';

const ManageAudit = () => <WorkDetail kind="audit" idKey="audit_id" listPath="/audits" listLabel="Audits" />;

export default ManageAudit;
